import PlgIcon from "plg/shell/PlgIcon";
import { useMeeting } from "plg/meeting/MeetingContext";

interface Props {
  /** Classes for the button (and for the "Meeting requested" state), e.g. "plg-hcall" or "plg-btn plg-btn--outline plg-btn--lg". */
  className: string;
  /** Classes once sent; defaults to `className`. */
  sentClassName?: string;
  /** meeting_panel_opened.entry_point */
  entry: string;
}

/** The one CTA (prototype door()): opens the meeting request, or reads "Meeting requested" once sent. */
function MeetingDoor({ className, sentClassName, entry }: Props) {
  const meeting = useMeeting();
  if (meeting?.sent) {
    return (
      <span className={`${sentClassName ?? className} plg-is-sent is-sent`}>
        <PlgIcon name="check" />
        <span className="plg-door__label">Meeting requested</span>
      </span>
    );
  }
  return (
    <button type="button" className={className} onClick={() => meeting?.open(entry)}>
      <PlgIcon name="calCheck" />
      <span className="plg-door__label">Request a meeting</span>
    </button>
  );
}

export default MeetingDoor;
